<template>
  <vs-popup id="popupRiskInfo" title="가능성(빈도)" :active.sync="popupActiveSync">
    <div class="p-4">
      <div class="risk-info-header">
        <span>가능성(빈도)</span>
      </div>
      <div>
        <div class="risk-info-body">
          <span style="border-top: none; border-right: none;">최상</span>
          <span style="border-top: none; border-right: none; font-weight: bold; color: #E42728">매우높음</span>
          <span style="border-top: none; border-right: none;">5</span>
          <span style="border-top: none; display: block;">
            <p style="font-weight: bold; text-align: center; text-decoration: underline;">피해가 발생할 가능성이 매우 높음</p>
            <p style="text-align: center;">해당 안전대책이 되어 있지 않고 표시·표지가 있어도 제대로 정리 되거나 갖추어 있지 않으며, 안전수칙·작업표준 등도 없음</p>
          </span>
        </div>

        <div class="risk-info-body">
          <span style="border-top: none; border-right: none;">상</span>
          <span style="border-top: none; border-right: none; font-weight: bold; color: #E42728">높음</span>
          <span style="border-top: none; border-right: none;">4</span>
          <span style="border-top: none; display: block;">
            <p style="font-weight: bold; text-align: center; text-decoration: underline;">피해가 발생할 가능성이 높음</p>
            <p style="text-align: center;">가드·방호덮개, 기타 안전장치가 없거나 제대로 정리되거나 갖추어 있지 않고, 비상정지장치, 표시·표지는 웬만큼 설치되어 있으며, 안전수칙·작업표준 등은 있지만 지키기 어렵고 많은 주의를 해야 함</p>
          </span>
        </div>

        <div class="risk-info-body">
          <span style="border-top: none; border-right: none;">중</span>
          <span style="border-top: none; border-right: none; font-weight: bold; color: #E42728">보통</span>
          <span style="border-top: none; border-right: none;">3</span>
          <span style="border-top: none; display: block;">
            <p style="font-weight: bold; text-align: center; text-decoration: underline;">부주의 하면 피해가 발생할 가능성이 있음</p>
            <p style="text-align: center;">가드·방호덮개 또는 안전장치 등은 설치되어 있지만, 가드가 낮거나 간격이 벌어져 있는 등 제대로 정리되거나 갖추어 있지 않고 위험 영역 접근, 위험원과의 접촉이 있을 수 있으며, 안전수칙·작업표준 등은 있지만 일부 준수하기 어려운 점이 있음</p>
          </span>
        </div>

        <div class="risk-info-body">
          <span style="border-top: none; border-right: none;">낮음</span>
          <span style="border-top: none; border-right: none; font-weight: bold; color: #FF8510">하</span>
          <span style="border-top: none; border-right: none;">2</span>
          <span style="border-top: none; display: block;">
            <p style="font-weight: bold; text-align: center; text-decoration: underline;">피해가 발생할 가능성이 낮음</p>
            <p style="text-align: center;">가드·방호덮개 등으로 보호되어 있고, 안전장치가 설치되어 있으며, 위험 영역에서의 출입이 곤란한 상태이고, 안전수칙·작업표준(서)등이 정비되어 있고 준수하기 쉬우나, 피해의 가능성이 남아 있음</p>
          </span>
        </div>

        <div class="risk-info-body">
          <span style="border-top: none; border-right: none;">매우낮음</span>
          <span style="border-top: none; border-right: none; font-weight: bold; color: #28C76F">최하</span>
          <span style="border-top: none; border-right: none;">1</span>
          <span style="border-top: none; display: block;">
            <p style="font-weight: bold; text-align: center; text-decoration: underline;">피해가 발생할 가능성이 없음</p>
            <p style="text-align: center;">전반적으로 안전조치가 잘 되어 있음</p>
          </span>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  components: {
  },
  computed: {
    popupActiveSync: {
      get () {
        return this.value
      },
      set () {
        this.handleCloseSelf()
      }
    }
  },
  methods: {
    handleCloseSelf () {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.risk-info-body {
  display: grid;
  grid-template-columns: 109px 109px 109px 812px;
  span {
    padding: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #DEDEDE;

    &.left {
      justify-content: flex-start;
    }
  }
}
.risk-info-header {
  //display: grid;
  //grid-template-columns: 109px 109px 109px 572px 236px;
  //grid-template-areas: "A A A B C" "D E F B C";
  //grid-template-rows: 40px 40px;
  background-color: #F9F9F9;
  span {
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border: 1px solid #DEDEDE;
  }
}
</style>
<style>

#popupRiskInfo > .vs-popup {
  width: 1167px !important;
}

#popupRiskInfo > .vs-popup > .vs-popup--content {
  width: 100%;
  padding: 0;
  margin: 0;
}

#popupRiskInfo > .vs-popup > .vs-popup--content > .vs-row {
  padding: 24px;

}

</style>
